import { useLocation, useNavigate } from "react-router-dom";
import { useAtomValue } from "jotai";
import { isBackstageUserAtom } from "../../atoms/userAtom";
import { BackstageHeader } from "./backstageHeader";

export function ModalHeader({ title }: { title: string }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isBackstageUser = useAtomValue(isBackstageUserAtom);

  return isBackstageUser ? (
    <BackstageHeader title={title} />
  ) : (
    <div className="navbar bg-base-100 w-full z-10 shadow flex-shrink-0">
      <div className={"navbar-start"}></div>
      <div className={"navbar-center"}>
        <label className={"text-xl"}>{title}</label>
      </div>
      <div className={"navbar-end"}>
        <button
          className={"btn btn-square btn-ghost"}
          onClick={() =>
            navigate(pathname.substring(0, pathname.lastIndexOf("/")))
          }
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="w-6 h-6"
          >
            <path
              fillRule="evenodd"
              d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </div>
    </div>
  );
}
